export default "__VITE_ASSET__Cf6HljDE__"